var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairtransportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    style: {
      backgroundColor: "transparent"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 100,
    stroke: "currentColor",
    strokeWidth: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    fontFamily: "Arial Black, Arial, sans-serif",
    fontSize: 160,
    fontWeight: 900,
    fill: "currentColor",
    textAnchor: "middle",
    dominantBaseline: "central",
    style: {
      letterSpacing: "-5px"
    }
  }, "\n    F\n  "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairtransportIcon);
export default __webpack_public_path__ + "static/media/fairtransport-icon.6ae8aebdbc1ce5279c99ac35ae96003d.svg";
export { ForwardRef as ReactComponent };